import React from "react";
import { observer } from "mobx-react";
import { HelperDate } from "../../helper/HelperDate";
import Select from "react-select";
import { withStore } from "../../hocs";

interface Props {
  arData: [];
  onLoginRoot: (id: number) => void;
  onFilterUser: (e: any) => void;
}

// @ts-ignore
@withStore
@observer
export class AdminUserLog extends React.Component<Props, {}> {
  render() {
    const { arData } = this.props;
    // @ts-ignore
    const { store } = this.props;

    const { onChangeInputCity, onInputSelectChangeCity,onChangeIsError,isErrorFilter } =
      store.pageAdminUserLogStore;
    const { citySelected, cityOption, cityError } = store.pageAdminUserLogStore;

    return (
      <>
        <div className="subtitle">
          <div className="subtitle-text">
            <span className="subtitle__text">История:</span>
          </div>
          <div className="subtitle-nav">
            <div className="search-on-page">
              <div className="search-form-on-page-wrapper">
              <label onClick={() => onChangeIsError()}
                               className={isErrorFilter ? "filter__bg filter__box-active" : "filter__bg filter__box-empty"}
                        >
                            <input className="select-filter__checkbox" type="checkbox"/>
                            <span className="filter__item">Ошибки</span>
                        </label>
                <div className="input-box">
                  <div className="select-box">
                    <span className="select-box-label-title">
                      Пользователь, email
                    </span>
                    <Select
                      className="select"
                      classNamePrefix="react-select"
                      defaultValue={citySelected}
                      value={citySelected}
                      onChange={(e: any) => onChangeInputCity(e)}
                      onInputChange={(e: string) => onInputSelectChangeCity(e)}
                      options={cityOption}
                    />
                  </div>
                  {cityError.length ? (
                    <span className="input-box__error-text">{cityError}</span>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="user-list-topline no-space-between">
          <div className="td2-1">
            <div className="td2-1-text"></div>
            <div className="">
              <span className="basket-item-top-line__text">Дата</span>
            </div>
          </div>
          <div className="td2-3">
            <span className="basket-item-top-line__text">Пользователь</span>
          </div>
          <div className="td2-4">
            <span className="basket-item-top-line__text">IP</span>
          </div>
          <div className="td2-7">
            <span className="basket-item-top-line__text">Действие</span>
          </div>
          <div className="td2-7">
            <span className="basket-item-top-line__text">
              Система/ Браузер / Устройство
            </span>
          </div>
          <div className="td2-7">
            <span className="basket-item-top-line__text">Ошибка</span>
          </div>
        </div>
        <div className="user-list">
          {arData.length ? (
            arData.map((item: any) => (
              <>
                <div key={"data-" + item.id} className="user-list-item ">
                  <div className="td2-1 list-item-border">
                    <div className="td2-1-text"></div>
                    <div className="td2-1-text cursor">
                      <div className="client-mobile-title">Дата</div>
                      <div className="td2-7-padding">
                        <span className="list-item-text__normal">
                          {HelperDate.getDate(item.createdAt)}
                        </span>
                      </div>
                      <div>
                        <span className="list-item-text__normal ">
                          {HelperDate.getTime(item.createdAt)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="td2-3 list-item-border">
                    <div className="client-mobile-title">Пользователь</div>
                    <span className="list-item-text__normal">
                      {item.userName ? item.userName : item.userEmail}
                    </span>
                  </div>
                  <div className="td2-3 list-item-border">
                    <div className="client-mobile-title">IP</div>
                    <span className="list-item-text__normal">
                      {item.ip ? item.ip : "-"}
                    </span>
                  </div>
                  <div className="td2-7 list-item-border">
                    <div className="client-mobile-title">Действие</div>
                    <span className="list-item-text__normal">
                      {item?.actionName} {item?.actionText}
                    </span>
                  </div>
                  {item.os && item.os.os ? (
                    <div className="td2-7 list-item-border">
                      <div className="client-mobile-title">
                        Система/ Браузер / Устройство
                      </div>
                      <span className="list-item-text__normal">
                        {item?.os.os.name} версия {item?.os.os.version} /
                        {item?.os.client.name} версия {item?.os.client.version}{" "}
                        /
                        {item?.os.device !== null ? (
                          <>
                            {item?.os.device.type} брэнд -{" "}
                            {item?.os.device.brand}, модель -{" "}
                            {item?.os.device.model}
                          </>
                        ) : (
                          <>-</>
                        )}
                      </span>
                    </div>
                  ) : (
                    <div className="td2-7 list-item-border">
                      <div className="client-mobile-title">
                        Система/ Браузер / Устройство
                      </div>
                      <span className="list-item-text__normal">- / - /-</span>
                    </div>
                  )}
                  <div className="td2-7 list-item-border">
                    <div className="client-mobile-title">Ошибка</div>
                    <span className="list-item-text__normal">
                     {item?.isError ? item.error: 'Нет'}
                    </span>
                  </div> 
                </div>
              </>
            ))
          ) : (
            <p className="search-on-page__text"> список пуст</p>
          )}
        </div>
      </>
    );
  }
}
